/*
================================================================ 
          Copyright (c) 2018-2021 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React, { useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import { withTranslation, Trans } from "react-i18next";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";

const ResumeDialog = (props) => {
  return (
    <Dialog
      disableScrollLock={true}
      open={props.isOpen}
      PaperComponent={DraggableDialogPaper}
    >
      <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
        {props.t("RESUME_SUBSCRIPTION_CONFIRMATION_MESSAGE")}
      </DialogTitle>
      <DialogActions>
        <Button
          onClick={() => {
            props.close();
          }}
        >
          {props.t("NO")}
        </Button>
        <Button
          onClick={() => {
            props.updateSubscriptionByAction(props.serviceInstanceId, "RESUME");
          }}
        >
          {props.t("YES")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(ResumeDialog);
